module.exports = __webpack_public_path__ + "img/howto_ico01.cec5f82e.png";